export const SUPPORTED_STATE = [
  { value: 'AZ', label: 'AZ' },
  { value: 'CA', label: 'CA' },
  { value: 'WA', label: 'WA' },
];
